/**
 * Which project pages a project type uses (row 4aa3e0ec).
 *
 * The project's template manifest may list `hidden_surfaces`: project route
 * slugs ("develop", "hosting", "broadcast" ...) that do not fit its type. A
 * finance engagement (a bank's OnBase rollout) has no code to build or ship, so
 * its manifest hides the software-delivery pages. A software or general project
 * has no list, and every page stays.
 *
 * The list arrives with the template labels (GET /projects/{id}/template-labels,
 * via useTemplateLabels), and every door to a project page reads it through the
 * two helpers here: the project nav, the shelves, the command palette, the mode
 * picker and the routes themselves.
 */

/** The route slug of a project-scoped path: "/projects/p1/git-config?x" -> "git-config".
 *  null for the project's own landing page or a path outside a project. */
export function projectSurfaceOf(path: string | undefined | null): string | null {
  if (!path) return null;
  const m = /^\/projects\/[^/?#]+\/([^/?#]+)/.exec(path);
  return m ? m[1] : null;
}

/** True when `path` opens a page this project type does not use. */
export function isHiddenSurface(
  path: string | undefined | null,
  hidden: readonly string[] | undefined | null,
): boolean {
  if (!hidden || hidden.length === 0) return false;
  const slug = projectSurfaceOf(path);
  return slug !== null && hidden.includes(slug);
}
